module.exports = __webpack_public_path__ + "img/icon_htfx_empty.76bf1f50.png";